export default __webpack_public_path__ + "static/media/ihracat-pluskim.ab8cba19.mp4";